import { render, staticRenderFns } from "./SettingsOverlay.vue?vue&type=template&id=7ccc9f0c&"
import script from "./SettingsOverlay.vue?vue&type=script&lang=js&"
export * from "./SettingsOverlay.vue?vue&type=script&lang=js&"
import style0 from "./SettingsOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports